export default __webpack_public_path__ + "static/media/superman.2ebd5a59.png";